import { createContext, useContext, useSyncExternalStore, ReactNode } from "react";
import { walkUploadManager, type UploadRecord } from "@/lib/walkUploadManager";

type WalkUploadContextType = {
  uploads: UploadRecord[];
  startUpload: typeof walkUploadManager.startUpload;
  cancelUpload: typeof walkUploadManager.cancelUpload;
};

const WalkUploadContext = createContext<WalkUploadContextType | undefined>(undefined);

export function WalkUploadProvider({ children }: { children: ReactNode }) {
  const uploads = useSyncExternalStore(walkUploadManager.subscribe, walkUploadManager.getSnapshot);

  return (
    <WalkUploadContext.Provider
      value={{ uploads, startUpload: walkUploadManager.startUpload, cancelUpload: walkUploadManager.cancelUpload }}
    >
      {children}
    </WalkUploadContext.Provider>
  );
}

export function useWalkUpload() {
  const ctx = useContext(WalkUploadContext);
  if (!ctx) throw new Error("useWalkUpload must be used within a WalkUploadProvider");
  return ctx;
}
